
import { Helmet } from 'react-helmet';
import FooterSection from '@/components/FooterSection';

const Privacy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - The Liberated Consultant by Rey Marques</title>
        <meta name="description" content="Privacy Policy for The Liberated Consultant by Rey Marques." />
      </Helmet>
      
      <div className="min-h-screen bg-book-lightBg">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-md">
            <h1 className="text-3xl md:text-4xl font-bold mb-8 text-book-darkBlue">Privacy Policy</h1>
            
            <div className="prose max-w-none">
              <p className="mb-4">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">1. Information We Collect</h2>
              <p>We collect information you provide directly to us when you register for our book, sign up for our newsletter, or otherwise interact with our website.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">2. How We Use Your Information</h2>
              <p>We use the information we collect to provide, maintain, and improve our services, to send you marketing communications, and to respond to your inquiries.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">3. Sharing of Information</h2>
              <p>We do not share your personal information with third parties except as described in this privacy policy or with your consent.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">4. Your Choices</h2>
              <p>You can opt out of receiving marketing emails at any time by following the instructions provided in those emails.</p>
              
              <h2 className="text-xl font-semibold mt-6 mb-3">5. Contact Us</h2>
              <p>If you have any questions about this privacy policy, please contact us via <a href="https://www.linkedin.com/in/reymarques/" target="_blank" rel="noopener noreferrer" className="text-book-blue hover:text-book-red">LinkedIn</a>.</p>
            </div>
          </div>
        </div>
        <FooterSection />
      </div>
    </>
  );
};

export default Privacy;
